import axios from "axios";
//import FormData from "form-data";
import {AdminClientDetailEndPoint, AdminUpdateClientGCEndPoint, AdminAddClientMeterEndPoint, AdminEditClientMeterEndPoint, AdminClientDeleteMeterEndPoint, AdminEditClientEndPoint, AdminClientChangePasswordEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//     return response;
// }, function (error) {
//     return Promise.reject(error.response);
// });

class AdminClientDetailServices {
    static getAdminClientDetail(clientId) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminClientDetailEndPoint+ clientId, config);
    }

}

class AdminUpdateClientGCServices {
    static UpdateClientGC(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.put(AdminUpdateClientGCEndPoint+data.clientId+"/gc", data.saveGCObj, config);
    }

}

class AdminAddClientMeterServices {
    static addAdminClientMeter(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.post(AdminAddClientMeterEndPoint, data, config);
    }

}

class AdminEditClientMeterServices {
    static editAdminClientMeter(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.put(AdminEditClientMeterEndPoint+"/"+data.meterId, {name:data.name,isCheck:data.isCheck,params:data.params}, config);
    }

}


class AdminEditClientServices {
    static editAdminClient(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.put(AdminEditClientEndPoint+"/"+data.clientId, data.editClientObj, config);
    }

}

class AdminChangeClientPasswordServices {
    static changeAdminClientPassword(data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.put(AdminClientChangePasswordEndPoint+"/"+data.clientId+"/password", {password:data.newPassword}, config);
    }

}
class AdminDeleteMeterServices{
    static deleteMeter(meterId) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.delete(AdminClientDeleteMeterEndPoint+"/"+meterId, config);
    }

}

export {AdminClientDetailServices, AdminUpdateClientGCServices, AdminAddClientMeterServices, AdminEditClientMeterServices, AdminEditClientServices, AdminChangeClientPasswordServices, AdminDeleteMeterServices};
